import { Dispatch } from 'react-redux';
import { ActioningState } from './actioning.reducer';
import { requestAction } from '@common/components/common.actions';
import { authService } from '@services/AuthService';
import { Action } from 'redux';
import { commentService } from '@services/CommentService';
import { CommentViewModel, CommentType } from '@models/Comment';
import { PageViewModel } from '../_models/common.models';

export enum ActioningActionType {
  SetActioningList = 'SetActioningList',
  CompleteComment = 'CompleteComment',
  BeginLoadActions = 'BeginLoadActions'
}

export interface SetActioningListAction extends Action {
  readonly type: ActioningActionType.SetActioningList;
  readonly actioningList: Array<CommentViewModel>;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly totalResults: number;
}

export interface BeginLoadActionsAction extends Action {
  readonly type: ActioningActionType.BeginLoadActions;
}

export function getActioningList(pageNumber: number, pageSize: number, orderDirection: string) {
  return async (dispatch: Dispatch<ActioningState>) => {
    return dispatch(
      requestAction(() => authService.userActions(pageNumber, pageSize, orderDirection), setActioningList)
    );
  };
}

export function beginLoadActions(): BeginLoadActionsAction {
  return {
    type: ActioningActionType.BeginLoadActions
  };
}

export function setActioningList(result: PageViewModel<CommentViewModel>): SetActioningListAction {
  return {
    type: ActioningActionType.SetActioningList,
    actioningList: result.results,
    pageNumber: result.page,
    pageSize: result.pageSize,
    totalResults: result.totalResults
  };
}

export interface CompleteCommentAction extends Action {
  readonly type: ActioningActionType.CompleteComment;
}

export function completeComment(id: number, type: CommentType) {
  return async (dispatch: Dispatch<ActioningState>) => {
    return dispatch(requestAction(() => commentService.completeComment(id, type), setCompleteComment));
  };
}
export function setCompleteComment(): CompleteCommentAction {
  return {
    type: ActioningActionType.CompleteComment
  };
}



// WEBPACK FOOTER //
// ./src/actioning/actioning.actions.tsx